<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 24 24"
  width="1.500em"
  height="1.500em"
  fill="currentColor"
  aria-hidden="true"
  focusable="false"
  ><path
    d="M6 11h16v2H6v-2Zm16 6H6v2h16v-2ZM6 5h16v2H6V5Zm-4 6h2v2H2v-2Zm2 6H2v2h2v-2ZM2 5h2v2H2V5Z"
  /></svg
>
